import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
// Define node positions for the network
const nodes = [{
  id: 1,
  x: 20,
  y: 20
}, {
  id: 2,
  x: 50,
  y: 15
}, {
  id: 3,
  x: 80,
  y: 30
}, {
  id: 4,
  x: 30,
  y: 50
}, {
  id: 5,
  x: 60,
  y: 60
}, {
  id: 6,
  x: 90,
  y: 50
}, {
  id: 7,
  x: 40,
  y: 80
}, {
  id: 8,
  x: 75,
  y: 85
}];
// Define connections between nodes
const connections = [{
  from: 1,
  to: 2
}, {
  from: 1,
  to: 4
}, {
  from: 2,
  to: 3
}, {
  from: 2,
  to: 5
}, {
  from: 3,
  to: 6
}, {
  from: 4,
  to: 5
}, {
  from: 4,
  to: 7
}, {
  from: 5,
  to: 6
}, {
  from: 5,
  to: 8
}, {
  from: 6,
  to: 8
}, {
  from: 7,
  to: 8
}];
export function GeometricPattern() {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0
  });
  useEffect(() => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return <div className="absolute inset-0 w-full h-full overflow-hidden bg-[#1a2d4a]" data-id="element-328">
      {/* Background subtle grid */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#d4a853 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-329" />

      <svg className="w-full h-full absolute inset-0" preserveAspectRatio="xMidYMid slice" data-id="element-330">
        {/* Connections */}
        {connections.map((conn, i) => {
        const start = nodes.find(n => n.id === conn.from);
        const end = nodes.find(n => n.id === conn.to);
        if (!start || !end) return null;
        return <g key={`conn-${i}`} data-id="element-331">
              {/* Base line */}
              <motion.line x1={`${start.x}%`} y1={`${start.y}%`} x2={`${end.x}%`} y2={`${end.y}%`} stroke="#d4a853" strokeWidth="1" strokeOpacity="0.2" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 0.2
          }} transition={{
            duration: 1.5,
            delay: i * 0.1
          }} data-id="element-332" />

              {/* Traveling packet */}
              <motion.circle r="3" fill="#d4a853" data-id="element-333">
                <animateMotion dur={`${3 + i % 3}s`} repeatCount="indefinite" path={`M${start.x * (windowSize.width > 0 ? windowSize.width / 100 : 10)},${start.y * (windowSize.height > 0 ? windowSize.height / 100 : 10)} L${end.x * (windowSize.width > 0 ? windowSize.width / 100 : 10)},${end.y * (windowSize.height > 0 ? windowSize.height / 100 : 10)}`} data-id="element-334" />
              </motion.circle>
            </g>;
      })}

        {/* Nodes */}
        {nodes.map((node, i) => <g key={`node-${node.id}`} data-id="element-335">
            {/* Pulsing outer ring */}
            <motion.circle cx={`${node.x}%`} cy={`${node.y}%`} r="20" stroke="#d4a853" strokeWidth="1" fill="none" initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: [0.8, 1.5, 0.8],
          opacity: [0.1, 0, 0.1]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: i * 0.2
        }} data-id="element-336" />

            {/* Hexagon Shape (approximated with polygon) */}
            <motion.path d={`M ${node.x}% ${node.y}% m -8, 0 l 4, -7 l 8, 0 l 4, 7 l -4, 7 l -8, 0 z`} fill="#0a1628" stroke="#d4a853" strokeWidth="2" initial={{
          scale: 0,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          type: 'spring',
          stiffness: 260,
          damping: 20,
          delay: i * 0.1 + 0.5
        }} whileHover={{
          scale: 1.2,
          fill: '#1a2d4a',
          cursor: 'pointer'
        }} data-id="element-337" />

            {/* Inner dot */}
            <motion.circle cx={`${node.x}%`} cy={`${node.y}%`} r="3" fill="#d4a853" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: i * 0.1 + 0.8
        }} data-id="element-338" />
          </g>)}
      </svg>

      {/* Overlay gradient to blend edges */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-transparent to-transparent opacity-60 pointer-events-none" data-id="element-339" />
      <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-[#0a1628] opacity-30 pointer-events-none" data-id="element-340" />
    </div>;
}